import { toGraySchoolValue } from "./graySchoolRouting";
import { STORAGE_KEYS } from "../constants/storageKeys";

export function buildSystemHavePermissionUrl(systemUrl, params) {
  return `${systemUrl}/havePermission??staffer_id=${params.staffer_id}&token=${params.token}&school_id=${params.school_id}&company_id=${params.company_id}&language=${params.language}&postbe_id=${params.postbe_id}`;
}

export function buildChooseUrl(wpcUrl, params) {
  return `${wpcUrl}/choose?token=${params.token}&staffer_id=${params.staffer_id}&company_id=${params.company_id}&school_id=${params.school_id}&status=${params.status}&isAdmin=${params.isAdmin}&marketer_id=${params.marketer_id}&language=${params.language}`;
}

export function resolveGraySchoolStorageValue(schoolInfo) {
  const grayValue = toGraySchoolValue(schoolInfo && schoolInfo.school_isgrayscalecrm);
  return grayValue === null ? 0 : grayValue;
}

export function applySchoolSwitchContext({ Tool, store, schoolItem, schoolId, companyId, postbeId, schoolOneInfo }) {
  Tool.setStorage(STORAGE_KEYS.RE_POSTBE_ID, postbeId);
  Tool.setStorage(STORAGE_KEYS.SCHOOL_ITEM, schoolItem);
  Tool.setStorage(STORAGE_KEYS.SCHOOL_ID, schoolId);
  Tool.setStorage(STORAGE_KEYS.COMPANY_ID, companyId);
  Tool.setStorage(STORAGE_KEYS.IS_GRAY_SCHOOL, resolveGraySchoolStorageValue(schoolOneInfo));
  store.dispatch("setSchoolId", schoolId);
  store.dispatch("setCompanyId", companyId);
  Tool.setStorage(STORAGE_KEYS.OPEN_MENU, ["0"]);
  Tool.setStorage(STORAGE_KEYS.SLIDER_ACTIVE_INDEX, "0-1");
  Tool.setStorage(STORAGE_KEYS.STATUS, schoolOneInfo.status);
  return schoolOneInfo.status;
}
